import { getPercentageAdjustment } from '..';

/**
 * @method getPreviousLocationPercentage
 */
const getPreviousLocationPercentage = (frame, percentageScrolled) => {
  // get the percentage amount to scroll the document
  const percentageAdjustment = getPercentageAdjustment(frame);

  // calculate the pervious percentage of document
  const newPercentageOfDocument = Math.max(
    0,
    percentageScrolled - percentageAdjustment,
  );

  return newPercentageOfDocument;
};

export default getPreviousLocationPercentage;
